import React, { Component } from 'react';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import Typography from '@material-ui/core/Typography';
import AttachFileIcon from "@material-ui/icons/AttachFile";
import AutorenewIcon from '@material-ui/icons/Autorenew';
import PublishIcon from '@material-ui/icons/Publish';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";

import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

export class ReportRevisionSend extends Component {

    render() {
        //const { title, onChangeCommentText, comment, mrFile,
        //    mqFile, additionalFile, extendDeadlineForMonitor,
        //    sendRevision, onChangeMQ, onChangeMR } = this.props;
        const { title, onChangeCommentText, comment,
            sendRevision, onChangeMQ, onChangeMR, onChangeAdditional,
            plannedDate, userRole, countOfRevision, isFetching,
            submittingDate, onChangeDate, postAsUser, onPostAsUserChange,
            userRoleMission, userType, typeOfROM, onChangeNS, onChangeNW,
            plannedDateInput, filenameMQ, filenameMR, filenameNS, filenameNW,
            filenameAdditional } = this.props;

        //console.log("userrole");
        //console.log(userRole)

        return (
            <Card>
                <CardHeader title={title} className='romis-card-header' />
                <Grid container xs={12} spacing={2}>

                    <Grid item xs={3} md={3}>

                        {
                            //        userType === 2 && userRoleMission === -1 ?

                            //            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            //                <KeyboardDatePicker
                            //                    margin="normal"
                            //                    variant="inline"
                            //                    label="Planned Date:"
                            //                    format="dd/MM/yyyy"
                            //                    fullWidth
                            //                    onChange={value => {
                            //                        onChangeDate("plannedDateInput", value);
                            //                    }}
                            //                    //value={
                            //                    //    fieldPhaseStartDate === "" ? new Date() : fieldPhaseStartDate
                            //                    //}
                            //                    value={plannedDateInput}
                            //                    name="plannedDateInput"
                            //                    InputLabelProps={{
                            //                        shrink: true
                            //                    }}
                            //                    autoOk
                            //                />
                            //            </MuiPickersUtilsProvider>

                            //            :

                            //            <Typography className="clr-gray-2" variant="caption"><strong>Planned Date:</strong>{plannedDate}</Typography>

                        }
                    </Grid>


                    {
                        userType === 2 && userRoleMission === -1 ?

                            <Grid item xs={3} md={3}>
                                <Autocomplete
                                    options={userRole}
                                    getOptionLabel={option => option.LoginUsername + " " + option.LoginEmail + " " + option.LoginName + " " + option.LoginSurname}
                                    autoComplete
                                    includeInputInList
                                    onChange={onPostAsUserChange}
                                    renderInput={params => (
                                        <TextField {...params} label="Post as User" margin="normal" fullWidth />
                                    )}
                                    value={postAsUser}
                                />
                            </Grid>

                            : null
                    }

                    {
                        userType === 2 && userRoleMission === -1 ?

                            <Grid item xs={3} md={3}>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <KeyboardDatePicker
                                        margin="normal"
                                        variant="inline"
                                        label="Post with Date:"
                                        format="dd/MM/yyyy"
                                        fullWidth
                                        onChange={value => {
                                            onChangeDate("submittingDate", value);
                                        }}
                                        //value={
                                        //    fieldPhaseStartDate === "" ? new Date() : fieldPhaseStartDate
                                        //}
                                        value={submittingDate}
                                        name="submittingDate"
                                        InputLabelProps={{
                                            shrink: true
                                        }}
                                        autoOk
                                    />
                                </MuiPickersUtilsProvider>
                            </Grid>

                            : null
                    }

                </Grid>
                <CardContent>
                    <Grid container spacing={3} >
                        <Grid item style={{ marginTop: 15 }}>

                            <Grid item style={{ display: typeOfROM === 1 | typeOfROM === 2 ? "block" : "none" }}>
                                {
                                    //<Button variant="outlined" color="primary">
                                    //    MQ DOWLOAD
                                    //</Button>
                                    //<input
                                    //    id="fileMQ"
                                    //    name="fileMQ"
                                    //    type="file"
                                    //    onChange={onChangeMQ}
                                    ///>
                                }
                                <input
                                    style={{ display: "none" }}
                                    id="contained-button-file-mq"
                                    name="fileMQ"
                                    multiple
                                    type="file"
                                    onChange={onChangeMQ}
                                />
                                <label htmlFor="contained-button-file-mq" style={{ width: "100%" }}>
                                    <Button
                                        variant="outlined"
                                        color="primary"
                                        size="large"
                                        component="span"
                                        fullWidth
                                        startIcon={<AttachFileIcon />}
                                        disabled={!isFetching && (typeOfROM === 1 | typeOfROM === 2) ? false : true}
                                    >
                                        MQ UPLOAD
                                    </Button>
                                </label>
                                <Typography
                                    variant="caption"
                                    component="h2"
                                    style={{
                                        display: "none" ? filenameMQ === "" : "block"
                                    }}
                                >
                                    {filenameMQ}
                                </Typography>
                            </Grid>
                            <Grid item style={{ marginTop: 10, display: typeOfROM === 1 | typeOfROM === 2 ? "block" : "none" }} >
                                {
                                    //<Button variant="outlined" color="primary">
                                    //    MR DOWLOAD
                                    //</Button>
                                    //<input
                                    //    id="fileMR"
                                    //    name="fileMR"
                                    //    type="file"
                                    //    onChange={onChangeMR}
                                    ///>
                                }

                                <input
                                    style={{ display: "none" }}
                                    id="contained-button-file-mr"
                                    name="fileMR"
                                    multiple
                                    type="file"
                                    onChange={onChangeMR}
                                />
                                <label htmlFor="contained-button-file-mr" style={{ width: "100%" }}>
                                    <Button
                                        variant="outlined"
                                        color="primary"
                                        size="large"
                                        component="span"
                                        fullWidth
                                        startIcon={<AttachFileIcon />}
                                        disabled={!isFetching && (typeOfROM === 1 | typeOfROM === 2) ? false : true}
                                    >
                                        MR UPLOAD
                                    </Button>
                                </label>
                                <Typography
                                    variant="caption"
                                    component="h2"
                                    style={{
                                        display: "none" ? filenameMR === "" : "block"
                                    }}
                                >
                                    {filenameMR}
                                </Typography>
                            </Grid>
                            <Grid item style={{ display: typeOfROM === 3 | typeOfROM === 4 ? "block" : "none" }} >
                                <input
                                    style={{ display: "none" }}
                                    id="contained-button-file-ns"
                                    name="fileNS"
                                    multiple
                                    type="file"
                                    onChange={onChangeNS}
                                />
                                <label htmlFor="contained-button-file-ns" style={{ width: "100%" }}>
                                    <Button
                                        variant="outlined"
                                        color="primary"
                                        size="large"
                                        component="span"
                                        fullWidth
                                        startIcon={<AttachFileIcon />}
                                        disabled={!isFetching && (typeOfROM === 3 | typeOfROM === 4) ? false : true}
                                    >
                                        NS UPLOAD
                                    </Button>
                                </label>
                                <Typography
                                    variant="caption"
                                    component="h2"
                                    style={{
                                        display: "none" ? filenameNS === "" : "block"
                                    }}
                                >
                                    {filenameNS}
                                </Typography>
                            </Grid>
                            <Grid item style={{ display: typeOfROM === 5 | typeOfROM === 6 ? "block" : "none" }} >
                                <input
                                    style={{ display: "none" }}
                                    id="contained-button-file-nw"
                                    name="fileNW"
                                    multiple
                                    type="file"
                                    onChange={onChangeNW}
                                />
                                <label htmlFor="contained-button-file-nw" style={{ width: "100%" }}>
                                    <Button
                                        variant="outlined"
                                        color="primary"
                                        size="large"
                                        component="span"
                                        fullWidth
                                        startIcon={<AttachFileIcon />}
                                        disabled={!isFetching && (typeOfROM === 5 | typeOfROM === 6) ? false : true}
                                    >
                                        NW UPLOAD
                                    </Button>
                                </label>
                                <Typography
                                    variant="caption"
                                    component="h2"
                                    style={{
                                        display: "none" ? filenameNW === "" : "block"
                                    }}
                                >
                                    {filenameNW}
                                </Typography>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} sm container>
                            <Grid item xs container direction="column" spacing={2}>
                                <Typography variant="subtitle2">
                                    <strong>
                                        Comment
                                   </strong>
                                </Typography>
                                <TextareaAutosize name="revisionComment" rows={6} value={comment} onChange={onChangeCommentText} />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid container spacing={6} className="mt-1">
                        {
                            //<Grid xs={6} item>
                            //    <Button variant="outlined" color="primary" fullWidth>
                            //        <PublishIcon style={{ paddingRight: "8px" }} /> Additional File
                            //   </Button>
                            //</Grid >
                        }

                        <Grid xs={6} item>
                            <input
                                style={{ display: "none" }}
                                id="contained-button-file-additional"
                                name="fileAdditional"
                                multiple
                                type="file"
                                onChange={onChangeAdditional}
                            />
                            <label htmlFor="contained-button-file-additional" style={{ width: "100%" }}>
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    size="large"
                                    component="span"
                                    fullWidth
                                    startIcon={<PublishIcon />}
                                    disabled={isFetching ? true : false}
                                >
                                    Additional File
                                </Button>
                            </label>
                            <Typography
                                variant="caption"
                                component="h2"
                                style={{
                                    display: "none" ? filenameAdditional === "" : "block"
                                }}
                            >
                                {filenameAdditional}
                            </Typography>
                        </Grid>

                        <Grid item xs={6}>
                            <Button variant="outlined" color="primary"
                                onClick={sendRevision} fullWidth
                                disabled={isFetching ? true : false}>
                                <AutorenewIcon style={{ paddingRight: "8px" }} />
                                {countOfRevision > 0 ? "Send for Revision" : "Send Draft"}
                            </Button>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        )
    }
}





// WEBPACK FOOTER //
// ./src/components/ReportRevisionSend.js